import { fetchData } from '../../global-declare-components/api/network';

const speakersAPI = {
  fetch:(slug, params) => fetchData(`/api/landing-page/${slug}/speakers`, {params})
};

export default speakersAPI;
